import { Router, ActivatedRoute } from '@angular/router';
import { ServicesService } from './../../services/servicesService';
import { BaseComponent } from './../../../../shared/Components/base/base.component';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Service } from '../../models/ServiceRate';

@Component({
  selector: 'ngx-service-detail',
  templateUrl: './service-detail.component.html',
  styleUrls: ['./service-detail.component.scss'],
})
export class ServiceDetailComponent extends BaseComponent implements OnInit {
  serviceDetail: Service = {} as Service;
  serviceId: number;
  dataSet = {
    showLabels: false,
    showNumber: false,
    colors: ['#F4BA38', '#F4BA38', '#F4BA38', '#F4BA38', '#F4BA38'],
  };

  constructor(
    public service: ServicesService,
    public route: Router,
    private activatedroute: ActivatedRoute,
    public sanitizer: DomSanitizer
  ) {
    super(route, service, null, null);
  }

  ngOnInit() {
    this.activatedroute.paramMap.subscribe((param) => {
      this.serviceId = +param.get('id');
      this.service.getById(this.serviceId).subscribe((res) => {
        this.serviceDetail = res;
        this.finishLoading = true;
      });
    });
  }

  download(fileName) {
    this.service.downloadFile(fileName).subscribe();
  }

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }
}
